import { render } from "./LimitLocationAvailabilityTable.vue?vue&type=template&id=6ba9e1ff"
import script from "./LimitLocationAvailabilityTable.vue?vue&type=script&lang=js"
export * from "./LimitLocationAvailabilityTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__